import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import customConfig from "/customConfig";
/*
* checkAuth:检查授权
* */
const routes = [
  {
    path: '/',
    name: 'index',
    meta:{checkAuth:true},
    component: ()=>import('@/views/index/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if(to.path == "/clear"){
    localStorage.removeItem(customConfig.openIdName)
    localStorage.removeItem(customConfig.userInfoName)
    next('/')
    return false
  }
  next()
})

export default router
